import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Box } from '@cp/ds/src/components/box';
import { Link } from '@cp/ds/src/components/link';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useConfig } from '@cp/shared/config';
import { stepsList, stores } from './constants';

export const HowItWork = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const config = useConfig();
  const IS_PAID_FEATURES_ARE_FREE = config.get('IS_PAID_FEATURES_ARE_FREE', false);
  const filteredStepsList = React.useMemo(
    () => (IS_PAID_FEATURES_ARE_FREE ? stepsList.filter((s) => s.id !== 'payment') : stepsList),
    [IS_PAID_FEATURES_ARE_FREE],
  );
  const desktopColumnsCount = filteredStepsList.length;

  return (
    <Stack gap={{ xs: 2.5, md: 7.5 }} sx={{ mb: { xs: 2.5, md: 7.5 } }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: `repeat(${desktopColumnsCount}, 1fr)` },
          gap: { xs: 1.5, md: 2.5 },
        }}
      >
        {filteredStepsList.map((el, i) => {
          const Icon = el.icon;
          return (
            <Stack
              alignItems={{ xs: 'flex-start', md: 'center' }}
              justifyContent="flex-start"
              key={i}
              spacing={1}
              sx={{
                textAlign: { xs: 'start', md: 'center' },
                border: `1px solid ${theme.palette['gray middle']}`,
                borderRadius: { xs: 2, md: 2.5 },
                p: { xs: '16px', md: '28px 20px' },
              }}
            >
              <Stack alignItems="center" direction={{ xs: 'row', md: 'column' }} spacing={{ xs: 2, md: 1.5 }} sx={{ width: '100%' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: { xs: '40px', md: '60px' },
                    height: { xs: '40px', md: '60px' },
                    backgroundColor: theme.palette[el.color],
                    borderRadius: '50%',
                  }}
                >
                  <Icon
                    sx={{
                      fontSize: { xs: '1.5rem', md: '2.25rem' },
                      color: 'gray',
                    }}
                  />
                </Box>
                <Typography
                  component="h3"
                  sx={{ typography: { xs: 'button bold', lg: 'h2', xl: 'h4' }, color: theme.palette['gray dark'] }}
                >
                  {el.title}
                </Typography>
              </Stack>
              <Typography component="h3" sx={{ typography: { xs: 'body', lg: 'button secondary' }, color: theme.palette['gray'] }}>
                {el.text}
              </Typography>
            </Stack>
          );
        })}
      </Box>
      <Stack direction="row" flexWrap="wrap" justifyContent="center" sx={{ gap: { xs: 1.5, md: 2.5 } }}>
        {stores.map((el, i) => {
          const Component = el.img;
          return (
            <Link external href={isMobile ? el.mobHref : el.href} key={i} sx={{ width: { xs: '169px', md: '230px' } }} underline={false}>
              <Component />
            </Link>
          );
        })}
      </Stack>
    </Stack>
  );
};
